import React from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var PeopleImmigration = function PeopleImmigration() {
  return _jsxs("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    children: [_jsxs("g", {
      clipPath: "url(#clip0_443_30694)",
      children: [_jsx("path", {
        d: "M109.209 80.5356C99.593 113.252 56.5187 120.662 30.0275 103.684C12.7052 92.5827 1.22909 77.6615 4.40053 55.6648C8.59006 26.6067 39.9378 13.1444 66.6519 17.878C95.0372 22.9078 118.035 50.5069 109.209 80.5356Z",
        fill: "#DFECFF"
      }), _jsx("path", {
        d: "M32.8408 19.0396C36.5401 16.3723 41.8243 17.6544 41.8243 17.6544C41.8243 17.6544 46.4437 15.4817 51.1802 17.9583C55.9167 20.4348 57.9493 21.4281 59.8469 25.4911C61.1362 28.2516 61.069 33.1962 61.069 33.1962L63.4172 41.6345L63.1836 48.8276L65.5815 56.5706L64.6563 62.8121L59.7673 73.2873L38.4224 70.5037L21.8914 74.9804C21.8914 74.9804 11.8123 71.9471 12.5062 67.5717C12.9723 64.6329 14.5646 64.4259 14.8235 62.1232C15.1002 59.6618 12.9954 59.9224 13.3414 56.6817C13.6875 53.441 17.494 53.339 18.1236 50.3331C18.6746 47.7025 15.7701 46.7895 16.8985 43.5572C18.1815 39.8824 20.9837 40.8365 21.8913 38.1446C22.524 36.2679 21.9744 35.5839 22.0554 33.0907C22.2663 26.5937 29.1415 21.7068 32.8408 19.0396Z",
        fill: "#2C1400"
      }), _jsx("path", {
        d: "M59.4346 52.0415L60.878 54.4954C61.4729 55.5067 61.456 56.7649 60.8342 57.7599L59.4346 59.9992",
        stroke: "#592D00",
        strokeWidth: "1.86671",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M39.3243 22.104C39.3243 22.104 38.8877 25.1045 37.8775 26.6857C36.5389 28.7809 32.8135 30.544 32.8135 30.544",
        stroke: "#592D00",
        strokeWidth: "1.86671",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M69.126 94.7657L49.401 77.7803C44.9081 73.9114 45.3224 66.8298 50.2358 63.5113L50.768 63.1519C54.0949 60.9049 58.5081 61.1349 61.5835 63.7155L81.2918 80.2534C84.752 83.157 85.5218 88.1768 83.0907 91.9839L82.5754 92.7909C79.6283 97.4061 73.2756 98.3389 69.126 94.7657Z",
        fill: "#002B72"
      }), _jsx("path", {
        d: "M51.6106 58.3147L52.1929 58.6065C59.2695 62.153 64.4808 69.9422 66.0836 77.6937C67.0175 82.2099 67.8273 87.221 67.4152 92.0666C67.0594 96.2498 63.6757 99.891 62.9176 103.896C61.5842 110.939 64.1051 116.697 64.1051 116.697L22.315 113.823L20.921 85.39C12.9089 82.9242 11.7093 72.0819 18.9886 67.9243L36.1554 58.1195C36.3656 57.9994 36.6043 57.9381 36.8463 57.942L51.028 58.1719C51.2304 58.1752 51.4296 58.224 51.6106 58.3147Z",
        fill: "#002B72"
      }), _jsx("path", {
        d: "M26.109 98.1186L28.7481 87.4798C29.3862 84.9072 32.7434 84.2598 34.2923 86.4106L41.9543 97.0494C43.4364 99.1074 41.9658 101.979 39.4297 101.979H29.1286C27.1069 101.979 25.6222 100.081 26.109 98.1186Z",
        fill: "#001745"
      }), _jsx("path", {
        d: "M17.4843 105.763C16.186 103.691 17.6755 101 20.1207 101H105.756C106.443 101 107 101.557 107 102.244V115.756C107 116.443 106.443 117 105.756 117H25.2136C24.785 117 24.3865 116.779 24.159 116.416L17.4843 105.763Z",
        fill: "#D0E4FF"
      }), _jsx("path", {
        d: "M26.9147 118.611L53.9784 114.808C56.8554 114.404 59.0697 112.063 59.3131 109.168L59.4329 107.744C59.7381 104.114 56.8746 101 53.2324 101H19.909C14.1216 101 11.4687 108.209 15.8756 111.96L22.0155 117.187C23.37 118.34 25.1532 118.858 26.9147 118.611Z",
        fill: "#75AFFF"
      }), _jsx("rect", {
        x: "53",
        y: "101",
        width: "40",
        height: "16",
        fill: "#8EBEFF"
      }), _jsx("rect", {
        x: "53",
        y: "101",
        width: "36",
        height: "15",
        fill: "#FBDDB1"
      }), _jsx("path", {
        d: "M53 101H85L53 115V101Z",
        fill: "#F7C14E"
      }), _jsx("path", {
        d: "M87.2344 108.047L91.5163 109.519V117.222H87.2344V108.047Z",
        fill: "#FBDDB1"
      }), _jsx("path", {
        d: "M53.2852 116.611L91.5166 116.611",
        stroke: "#CA7F00",
        strokeWidth: "1.86671"
      }), _jsx("path", {
        d: "M85.6074 56.9533L83.4379 61.5451C83.1205 62.217 83.3226 63.0196 83.9205 63.4611L89.2334 67.3837C90.0624 67.9958 91.2467 67.6473 91.612 66.6837L93.7313 61.0929C94.0051 60.3707 93.7074 59.5569 93.0321 59.1817L87.7694 56.258C86.9832 55.8212 85.9916 56.1401 85.6074 56.9533Z",
        fill: "#D39264"
      }), _jsx("path", {
        d: "M94.3955 67.2541L83.0888 92.4774C81.0296 97.0709 75.4008 98.8064 71.1125 96.17C67.3664 93.8669 66.0526 89.0506 68.1104 85.1643L81.0906 60.6507C81.3188 60.2196 81.8492 60.0491 82.286 60.2663L93.9754 66.0809C94.4075 66.2959 94.593 66.8137 94.3955 67.2541Z",
        fill: "#002B72"
      }), _jsx("path", {
        d: "M74.0321 73.4858L70.9736 78.6853",
        stroke: "#004DC0",
        strokeWidth: "1.86671",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M35.1602 49.2612H50.5083V64.6094C50.5083 68.8477 47.0725 72.2835 42.8342 72.2835C38.596 72.2835 35.1602 68.8477 35.1602 64.6094V49.2612Z",
        fill: "#D39264"
      }), _jsx("path", {
        d: "M36.8423 64.6988L50.6578 61.8925V55.6539L35.2246 54.6582V63.3766C35.2246 64.2297 36.0064 64.8686 36.8423 64.6988Z",
        fill: "#A35F21"
      }), _jsx("path", {
        d: "M55.5048 30.0528C54.8203 26.9014 49.98 24.8121 49.3115 24.5373C49.2591 24.5158 49.2071 24.4993 49.152 24.486C46.8665 23.9335 45.0312 24.3865 42.6681 24.5064C41.5927 31.124 36.3286 33.2455 33.0785 37.2871C33.0785 37.2871 29.7125 36.8136 28.4729 39.4662C27.2333 42.1188 27.5083 45.4948 30.1608 48.1474C31.4111 49.3976 32.6673 48.782 32.6673 48.782L34.6119 53.9833C35.0085 55.0441 35.7571 55.9367 36.7326 56.512L42.7271 60.0472C43.9585 60.7734 45.4004 61.059 46.8157 60.8568L48.2651 60.6497C50.2268 60.3695 51.942 59.1813 52.968 57.4858C55.1612 53.8614 57.4202 50.3023 57.6751 45.9682C57.9163 41.8688 56.1037 40.0387 56.2866 37.7693C56.4694 35.4999 56.0528 32.5758 55.5048 30.0528Z",
        fill: "#D39364"
      }), _jsx("path", {
        d: "M32.2214 45.639C31.7704 45.2243 30.679 44.29 31.5867 43.0099C32.4943 41.7298 31.9923 40.8895 31.1119 40.6895C30.5763 40.5678 29.923 40.7031 29.5647 41.6884",
        stroke: "#753C11",
        strokeWidth: "1.34913",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M19.5999 92.8275L15.9737 95.5834C14.4432 96.7466 14.9835 99.1695 16.8631 99.5722L19.9091 100.225C21.16 100.493 22.3822 99.6648 22.5969 98.4036L23.1771 94.995C23.5193 92.9846 21.2235 91.5936 19.5999 92.8275Z",
        fill: "#8EBEFF"
      }), _jsx("path", {
        d: "M23.4088 49.8354L24.7458 53.4644C24.9637 54.0557 24.8562 54.7179 24.4626 55.21L22.9997 57.0386C22.5225 57.6351 22.4741 58.4679 22.879 59.1157L23.4088 59.9635",
        stroke: "#592D00",
        strokeWidth: "1.86671",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M47.3459 45.9962L50.6641 45.6275C51.2626 45.561 51.7561 46.0899 51.6484 46.6823L51.5075 47.4568C51.4338 47.8624 51.0938 48.1659 50.6824 48.1934L48.144 48.3626C47.9017 48.3787 47.6631 48.2962 47.4825 48.1337L46.8436 47.5586C46.2665 47.0393 46.5743 46.0819 47.3459 45.9962Z",
        fill: "#A25F20"
      }), _jsx("path", {
        d: "M50.1543 39.707L51.956 44.1889C52.3677 45.2132 52.1193 46.3912 51.2927 47.1229C51.0708 47.3193 50.8508 47.5087 50.6587 47.6648",
        stroke: "#753C11",
        strokeWidth: "1.34913",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M47.5025 47.5992L46.5605 47.2261",
        stroke: "#753C11",
        strokeWidth: "1.34913",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M45.9076 33.585C45.9076 33.585 44.1927 33.0296 43.0228 33.0012C40.9282 32.9502 38.2164 34.906 38.2164 34.906",
        stroke: "#2C1400",
        strokeWidth: "1.66137"
      }), _jsx("path", {
        d: "M50.2665 33.7853C50.2665 33.7853 52.228 32.7077 54.5821 33.3968C55.9553 33.7988 56.9062 35.0187 56.9062 35.0187",
        stroke: "#2C1400",
        strokeWidth: "1.66137"
      }), _jsx("path", {
        d: "M8.43671 99.2124L14.3817 73.9333C15.7386 68.1635 22.3159 65.3806 27.4018 68.4243C30.6398 70.3621 32.2721 74.1562 31.4526 77.8396L25.8125 103.188C24.8251 107.627 20.6552 110.61 16.136 110.112C10.8187 109.526 7.21204 104.42 8.43671 99.2124Z",
        fill: "#002B72"
      }), _jsx("path", {
        d: "M47.6092 50.376C49.3063 50.0648 51.0827 50.7187 52.0861 51.1941C52.5453 51.4117 52.6648 51.9751 52.3396 52.3659C51.2149 53.7173 48.5432 56.393 45.5131 55.6581C42.5552 54.9407 41.5123 51.1927 41.1686 49.2754C41.0657 48.7014 41.565 48.2421 42.1325 48.3758C43.3824 48.6702 45.4049 49.2552 46.7462 50.1924C46.9961 50.367 47.3092 50.4309 47.6092 50.376Z",
        fill: "#6A2D0D"
      }), _jsx("path", {
        d: "M45.8737 53.0891C46.7525 53.4314 48.3187 52.7916 49.1881 52.372C49.3854 52.2767 49.3296 52.0007 49.1116 51.9793L46.4032 51.7135C46.3743 51.7107 46.3462 51.7023 46.3205 51.6887L44.1279 50.5355C43.9389 50.436 43.743 50.6253 43.8453 50.8128C44.2459 51.5463 45.013 52.7539 45.8737 53.0891Z",
        fill: "white"
      }), _jsx("path", {
        d: "M58.4788 100.106C60.1798 100.626 64.214 103.431 66.215 104.868C66.9305 105.382 67.2587 106.273 67.0666 107.137L66.0025 111.922C65.7453 113.078 64.638 113.843 63.4691 113.672L52.4797 112.065C52.0517 112.002 51.6195 111.97 51.1866 111.97L39.9305 111.963L39.512 100.951L46.0871 100.658C46.0871 100.658 56.1721 99.4019 58.4788 100.106Z",
        fill: "#D39364"
      }), _jsx("path", {
        d: "M57.3853 111.741L58.5108 101.285C58.5858 100.588 59.3736 100.22 59.9568 100.609L65.9623 104.615C66.8199 105.187 67.236 106.229 67.0087 107.234L65.9792 111.789C65.684 113.095 64.4088 113.934 63.0929 113.687L58.1414 112.759C57.6625 112.669 57.3332 112.226 57.3853 111.741Z",
        fill: "#BA7A3E"
      }), _jsx("path", {
        d: "M44.7228 113.925L16.2931 111.979C10.8165 111.604 6.95945 106.441 8.15377 101.083C9.19231 96.4239 13.6988 93.3952 18.405 94.1935L45.9144 98.8599C46.3718 98.9375 46.6951 99.3502 46.661 99.8128L45.6812 113.094C45.6448 113.588 45.2165 113.959 44.7228 113.925Z",
        fill: "#002B72"
      }), _jsx("path", {
        d: "M17.8223 95.0688L46.3371 99.1421",
        stroke: "#004DC0",
        strokeWidth: "1.86671",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M50.3423 85.1291L37.9971 67.6121C42.5656 68.4393 45.548 68.7842 50.3423 65.9438V85.1291Z",
        fill: "#F6A5AB"
      }), _jsx("path", {
        d: "M41.9511 67.1865C41.4397 67.1218 40.9727 67.4839 40.908 67.9953C40.8433 68.5067 41.2055 68.9737 41.7169 69.0384L41.9511 67.1865ZM46.0047 68.1125L45.818 67.1979L46.0047 68.1125ZM50.3909 67.032C50.8077 66.7287 50.8997 66.1449 50.5964 65.7282C50.2931 65.3114 49.7093 65.2194 49.2925 65.5227L50.3909 67.032ZM41.834 68.1125C41.7169 69.0384 41.717 69.0384 41.7171 69.0385C41.7171 69.0385 41.7172 69.0385 41.7173 69.0385C41.7175 69.0385 41.7178 69.0385 41.7181 69.0386C41.7186 69.0386 41.7193 69.0387 41.7202 69.0388C41.7219 69.0391 41.7243 69.0394 41.7273 69.0397C41.7332 69.0405 41.7416 69.0415 41.7523 69.0428C41.7736 69.0453 41.8043 69.0489 41.8434 69.0533C41.9216 69.0621 42.0336 69.0741 42.1725 69.0874C42.4497 69.1139 42.8364 69.1456 43.2759 69.1669C44.1323 69.2082 45.2728 69.2144 46.1913 69.027L45.818 67.1979C45.1407 67.3362 44.1958 67.3424 43.3659 67.3023C42.9622 67.2828 42.6054 67.2535 42.35 67.2291C42.2225 67.2169 42.1209 67.206 42.0521 67.1983C42.0176 67.1944 41.9914 67.1914 41.9743 67.1893C41.9658 67.1883 41.9595 67.1875 41.9556 67.187C41.9536 67.1868 41.9523 67.1866 41.9515 67.1865C41.9511 67.1865 41.9509 67.1864 41.9508 67.1864C41.9508 67.1864 41.9508 67.1864 41.9509 67.1864C41.9509 67.1864 41.9509 67.1865 41.951 67.1865C41.951 67.1865 41.9511 67.1865 41.834 68.1125ZM46.1913 69.027C47.2481 68.8113 48.3079 68.2962 49.0672 67.868C49.455 67.6492 49.7819 67.4431 50.0127 67.291C50.1284 67.2149 50.2205 67.1518 50.2849 67.1071C50.3171 67.0846 50.3424 67.0668 50.3602 67.0541C50.3691 67.0477 50.3762 67.0426 50.3813 67.0389C50.3839 67.0371 50.386 67.0356 50.3876 67.0344C50.3884 67.0339 50.3891 67.0334 50.3896 67.033C50.3899 67.0328 50.3902 67.0326 50.3904 67.0324C50.3905 67.0323 50.3906 67.0322 50.3907 67.0322C50.3908 67.0321 50.3909 67.032 49.8417 66.2773C49.2925 65.5227 49.2926 65.5226 49.2927 65.5225C49.2928 65.5225 49.2929 65.5224 49.2929 65.5224C49.293 65.5223 49.2931 65.5223 49.2931 65.5223C49.2932 65.5222 49.2931 65.5223 49.2929 65.5224C49.2926 65.5226 49.2918 65.5232 49.2905 65.5242C49.2879 65.526 49.2835 65.5292 49.2772 65.5336C49.2647 65.5425 49.2451 65.5564 49.2188 65.5747C49.1661 65.6114 49.087 65.6655 48.9858 65.7322C48.7828 65.8659 48.4931 66.0486 48.1502 66.242C47.4479 66.6381 46.5892 67.0406 45.818 67.1979L46.1913 69.027Z",
        fill: "#9B0022"
      }), _jsx("path", {
        d: "M42.8844 75.1332L35.4593 58.8403C35.2322 58.3421 34.6271 58.1454 34.1505 58.4149L26.0027 63.0223C25.396 63.3655 25.3658 64.2284 25.947 64.6131L42.4295 75.5217C42.6902 75.6942 43.014 75.4177 42.8844 75.1332Z",
        fill: "#002B72"
      }), _jsx("path", {
        d: "M67.0243 93.9708C69.0896 86.5584 68.7433 82.1446 64.7334 74.2852",
        stroke: "#004DC0",
        strokeWidth: "1.86671",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M50.4109 97.7661L49.3403 89.8L28.9873 70.2812L32.157 61.2725",
        stroke: "#004DC0",
        strokeWidth: "1.86671",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _jsx("path", {
        d: "M52.7051 90.8847L62.3534 68.4464L56.3476 60.6055",
        stroke: "#004DC0",
        strokeWidth: "1.86671",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _jsx("line", {
        x1: "83.7705",
        y1: "36.8281",
        x2: "88.3769",
        y2: "47.1646",
        stroke: "#002B72",
        strokeWidth: "1.86671"
      }), _jsx("rect", {
        x: "73.3477",
        y: "15.8652",
        width: "35.7012",
        height: "23.6896",
        transform: "rotate(-24.0198 73.3477 15.8652)",
        fill: "white"
      }), _jsx("path", {
        d: "M98.7223 21.2899C98.6397 21.1953 98.622 21.0603 98.6776 20.9476L100.217 17.8286C100.321 17.6166 100.161 17.37 99.9243 17.3801L99.7206 17.3888C99.5614 17.3956 99.4228 17.281 99.3995 17.1234L99.1841 15.6614C99.1503 15.432 98.8864 15.3189 98.6969 15.4525L97.7625 16.1117C97.6379 16.1996 97.4679 16.1842 97.3611 16.0754L97.2385 15.9505C97.0769 15.7858 96.7985 15.8482 96.7227 16.0662L96.3376 17.172C96.2372 17.4605 95.8245 17.4465 95.7438 17.1519L95.1031 14.8138C95.0359 14.5687 94.7192 14.5031 94.5602 14.7015L94.3673 14.9423C94.2636 15.0717 94.0772 15.0979 93.9421 15.0019C93.581 14.7455 92.9322 14.2868 92.5024 13.983C92.3094 13.8466 92.0413 13.9667 92.0143 14.2014C91.9542 14.7238 91.8636 15.5122 91.8135 15.9545C91.7951 16.1171 91.6543 16.2381 91.4907 16.2316L91.1227 16.217C90.8712 16.207 90.7126 16.4842 90.8486 16.696L92.1658 18.7464C92.3309 19.0034 92.0653 19.3197 91.7836 19.2014L90.7039 18.7484C90.4911 18.6591 90.2586 18.8244 90.273 19.0547L90.2839 19.2293C90.2934 19.3815 90.1912 19.5182 90.0425 19.552L88.9276 19.8062C88.7015 19.8577 88.6092 20.1295 88.7572 20.308L89.7002 21.4458C89.8019 21.5685 89.7945 21.7482 89.683 21.862L89.5403 22.0077C89.3749 22.1765 89.4508 22.4609 89.6784 22.5249L93.0266 23.4659C93.1476 23.4999 93.2362 23.6033 93.2513 23.728L93.3036 24.1594C93.3305 24.3818 93.5765 24.5037 93.7698 24.3904L95.5867 23.325C95.7467 23.2312 95.9527 23.2973 96.0282 23.4668L96.7689 25.1287C96.8388 25.2856 97.0227 25.3562 97.1797 25.2862L97.2545 25.2529C97.4114 25.183 97.4819 24.999 97.412 24.8421L96.6714 23.1802C96.5959 23.0107 96.6844 22.8133 96.8612 22.7571L98.8682 22.1183C99.0817 22.0504 99.1556 21.7859 99.0082 21.6172L98.7223 21.2899Z",
        fill: "#F35C6C"
      }), _jsx("rect", {
        x: "73.3477",
        y: "15.8652",
        width: "10.0097",
        height: "23.6896",
        transform: "rotate(-24.0198 73.3477 15.8652)",
        fill: "#F35C6C"
      }), _jsx("rect", {
        x: "97.4238",
        y: "5.13574",
        width: "9.34236",
        height: "23.6896",
        transform: "rotate(-24.0198 97.4238 5.13574)",
        fill: "#F35C6C"
      }), _jsx("path", {
        d: "M83.728 58.4928L84.8126 59.989C85.3664 60.7529 86.1274 61.3422 87.0056 61.687L90.0154 62.8689C91.7467 63.5487 93.6266 62.2994 93.6703 60.44L97.1193 51.3069L88.5749 42.6948C87.8716 41.0735 87.2873 40.5932 85.9298 40.5313C85.9298 40.5313 81.6344 49.0135 81.4018 50.3917C81.1693 51.7699 83.728 58.4928 83.728 58.4928Z",
        fill: "#D39264"
      }), _jsx("path", {
        d: "M88.378 56.8482C87.5874 55.7776 87.1217 54.174 86.849 52.7475C86.6064 51.4779 87.998 50.6986 89.0477 51.4527L94.4076 55.3035C94.959 55.6996 95.1898 56.4076 94.9778 57.0525L94.354 58.9503C94.0722 59.8077 93.1241 60.2395 92.3237 59.8225C91.0512 59.1595 89.2949 58.0897 88.378 56.8482Z",
        fill: "#BA7A3E"
      }), _jsx("line", {
        x1: "89.9082",
        y1: "52.75",
        x2: "93.5186",
        y2: "60.8516",
        stroke: "#002B72",
        strokeWidth: "1.86671"
      }), _jsx("path", {
        d: "M88.2708 43.4368L87.1165 48.0169C86.8567 49.0477 87.2031 50.1367 88.0106 50.8281L94.3775 56.2795",
        stroke: "#753C11",
        strokeWidth: "1.86671",
        strokeLinecap: "round"
      }), _jsx("path", {
        d: "M39.0596 37.2993L40.4465 37.6684C40.4465 37.6684 42.048 36.6947 43.3354 36.5807C44.6228 36.4668 46.678 37.6934 46.678 37.6934",
        stroke: "#200C00",
        strokeWidth: "1.24447"
      }), _jsx("circle", {
        cx: "43.4116",
        cy: "38.1993",
        r: "0.822185",
        transform: "rotate(-10.7708 43.4116 38.1993)",
        fill: "#200C00",
        stroke: "#200C00",
        strokeWidth: "1.24447"
      }), _jsx("path", {
        d: "M56.7091 37.4653L55.5682 37.8175C55.5682 37.8175 54.4263 36.6564 53.2844 36.4771C52.1426 36.2977 50.6598 37.5824 50.6598 37.5824",
        stroke: "#200C00",
        strokeWidth: "1.24447"
      }), _jsx("path", {
        d: "M52.5167 38.0325C52.3566 38.5848 52.6416 38.9873 52.9235 39.069C53.2054 39.1507 53.6614 38.9629 53.8215 38.4106C53.9815 37.8582 53.6966 37.4557 53.4147 37.3741C53.1328 37.2924 52.6768 37.4801 52.5167 38.0325Z",
        fill: "#200C00",
        stroke: "#200C00",
        strokeWidth: "1.24447"
      })]
    }), _jsx("defs", {
      children: _jsx("clipPath", {
        id: "clip0_443_30694",
        children: _jsx("rect", {
          width: "120",
          height: "120",
          fill: "white"
        })
      })
    })]
  });
};